/**
 * External dependencies
 */
import classnames from 'classnames';

/**
 * WordPress dependencies.
 */
import { InnerBlocks } from '@wordpress/block-editor';

/**
 * Inner dependencies.
 */

export default function save( props ) {
	const {
		className,
		attributes,
	} = props;
	const { hasAccordion } = attributes;
	const wrapperClasses = classnames(
		className,
		`gutenify-block-faq-wrapper`,
		hasAccordion ? 'gutenify-block-faq-accordion' : ''
	);
	return <div className={ wrapperClasses }><InnerBlocks.Content /></div>;
}
